import type { DigitalCompetency } from "@expert/shared-types";

export const digitalCompetencyDescriptions: Record<DigitalCompetency, string> = {
    "Tech savvy": "May like more advanced security solutions like VPNs, endpoint security, cloud protection.",
    "Tech savvy business owner":
        "May like more advanced security solutions like VPNs, endpoint security, cloud protection.",
    "Less tech savvy": "They may benefit from automated security tools and hands-free protection solutions.",
};
